module.exports = __webpack_public_path__ + "img/exp.d4c0629b.svg";